import { asyncActions, consultationReasonsActions } from '@docavenue/core';
import { ResultPageConsultationReasonHcd } from '@maiia/model/generated/model/api-patient/api-patient';
import { useQuery } from '@tanstack/react-query';
import { useDispatch } from 'react-redux';
import useIsPrescriber from './useIsPrescriber';

const useConsultationReasons = ({ centerId, specialityId, practitionerId }) => {
  const dispatch = useDispatch();
  const isPrescriber = useIsPrescriber();
  return useQuery(
    [
      'consultationReasons',
      { isPrescriber, centerId, specialityId, practitionerId },
    ],
    () =>
      asyncActions(
        dispatch,
        consultationReasonsActions.getActions(isPrescriber).getList({
          rootCenterId: centerId,
          checkAvailability: true,
          specialityId,
          practitionerId,
        }),
      ).then((res: ResultPageConsultationReasonHcd) => res.items),
    { enabled: Boolean(centerId) },
  );
};

export default useConsultationReasons;
